@import 'styles/mixins';
@import 'styles/variables';

.filters {
  display: flex;
  margin: 4px 0 18px 20px;
}

.avatar,
.icon {
  margin-right: 6px;

  [data-autopilot-system-redesign='on'] & {
    margin-right: 0;
  }
}

.filterItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  max-width: 280px;
  gap: 6px;
  cursor: pointer;

  .label,
  .counterAndCheck {
    display: flex;
    align-items: center;
    gap: 8px;

    .userName {
      @include line-clamp;
      max-width: 210px;
    }
  }
}

.filterItemContainer {
  color: var(--dark-80);
  border-radius: 6px;

  &:hover {
    background: var(--light-100);
  }

  &.selected {
    background: var(--selected-fill);

    .label {
      color: var(--light-100);
    }

    svg path {
      stroke: var(--light-100);
    }

    [data-autopilot-system-redesign='on'] & {
      border-radius: 4px;
      border: none;
      background: var(--dark-4);
      color: var(--dark-90);
      font-weight: 500;

      .label {
        color: var(--dark-90);
      }

      svg path {
        stroke: var(--dark-90);
      }

      .checkIcon {
        background: var(--dark-80);
        color: var(--light-100);
        border-radius: 50%;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        svg path {
          stroke: var(--light-100);
        }
      }
    }
  }

  &.disabled {
    opacity: 0.4;

    &:hover {
      background: transparent;
    }

    .filterItem {
      pointer-events: none;
    }
  }
}
